
import { configWebsiteReducer } from "../reducer/ConfigWebsiteReducer";

export const reducer = configWebsiteReducer;
